<template>
  <swiper :slides-per-view="1" :space-between="0" :modules="[Navigation, Pagination, Autoplay]" loop :threshold="swipeThreshold"
    :autoplay="{
    delay: props.slides.length > 1 ? 5000 : 500000000000,
    disableOnInteraction: false,
  }" :navigation="props.slides.length > 1" :initial-slide="1" :pagination="{
    clickable: true,
    type: 'custom',
    renderCustom: (swiper, current, total) =>
      `<div class='swiper-custom-pagination ${props.slides.length == 1 ? 'd-none' : ''}'>${current} ${$t(
        'global.of'
      )} ${total}</div>`,
  }">
    <swiper-slide v-for="(slide, key) in props.slides" :key="key"
      :class="`swiper-item ${slide.link_url[currentLocale] ? 'cursor--pointer' : ''}`"
      @click="redirect(slide.link_url[currentLocale], slide.new_tab)">
      <img :src="slide.poster[currentLocale]" class="swiper-img" draggable="false" alt="" />
      <div class="swiper-content" v-if="isShowText(slide)">
        <h3 :class="`swiper-title ${slide.color ? `text-${slide.color}` : ''}`">
          {{ slide.title[currentLocale] }}
        </h3>
        <p :class="`swiper-description ${slide.color ? `text-${slide.color}` : ''
          }`" v-html="slide.description[currentLocale]"></p>
      </div>
    </swiper-slide>
  </swiper>
</template>

<script setup>
import { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper-bundle.css";
import { defineProps, computed } from "vue";
import "../General/TextSlider/slider.scss";
import { useStore } from "vuex";

const store = useStore();
const props = defineProps({
  slides: Object,
});

// Default Swiper threshold is 0, so a click is handled as a swipe: the slide moves and the link click is cancelled.
const swipeThreshold = 10;
const currentLocale = computed(() => store.getters.getCurrentLocale);

/** show_text is a per-locale map after API migration; tolerate legacy booleans. */
const isShowText = (slide) => {
  const value = slide?.show_text;
  if (typeof value === "boolean") return value;
  if (value === 0 || value === "0") return false;
  if (value === 1 || value === "1") return true;
  if (value && typeof value === "object") {
    const localeValue = value[currentLocale.value];
    if (localeValue === undefined || localeValue === null) return true;
    return localeValue === true || localeValue === 1 || localeValue === "1";
  }
  return true;
};

const redirect = (link, new_tab) => {
  if (!link) return;

  const tab = new_tab ? "_blank" : "_self";
  window.open(link, tab);
};
</script>

<style scoped lang="scss">
@import "../../styles/_variables.scss";

.swiper,
.swiper-wrapper {
  height: 100%;
}

.swiper-item {
  height: 100%;
}

.swiper-content {
  color: white;
  background: rgba(0, 0, 0, 0.4);
  padding: 32px 125px 32px 32px;
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 100%;

  @media screen and (max-width: $lgBreakpoint) {
    padding: 35px 25px;
  }
}

.swiper-title {
  font-size: 35px;
  text-shadow: 1px 1px 10px rgb(0 0 0 / 50%);

  @media screen and (max-width: $lgBreakpoint) {
    font-size: 25px;
  }
}

.swiper-description {
  font-size: 18px;
  margin: 0;
  text-shadow: 1px 1px 10px rgb(0 0 0 / 50%);

  @media screen and (max-width: $lgBreakpoint) {
    font-size: 16px;

    br {
      display: none;
    }
  }
}

.swiper-img {
  width: 100%;
  height: inherit;
  pointer-events: none;
  -webkit-user-drag: none;
  user-select: none;
}
</style>
